import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";

const ROOT_TARGET = "";

/**
 * Второй путь к перемещению, помимо drag & drop: нативный HTML5 DnD не работает
 * на тач-устройствах и недоступен с клавиатуры.
 */
class AllureDockerMoveProjectDialog extends Component {
  state = { target: ROOT_TARGET };

  componentDidUpdate(prevProps) {
    // Диалог не размонтируется между открытиями: без сброса выбор папки
    // переживает Cancel. Сверять только projectId недостаточно — повторное
    // открытие того же проекта тогда показывает прошлый выбор с активной
    // кнопкой. Инвариант проще: диалог всегда открывается нейтральным.
    const isAnotherProject = prevProps.projectId !== this.props.projectId;
    const hasJustOpened = !prevProps.open && this.props.open;
    if (isAnotherProject || hasJustOpened) {
      this.setState({ target: ROOT_TARGET });
    }
  }

  handleTargetChange = (event) => {
    this.setState({ target: event.target.value });
  };

  moveProject = () => {
    this.props.moveProject(this.props.projectId, this.state.target || null);
    this.props.handleCloseDialog();
  };

  render() {
    const projectId = this.props.projectId || "";
    // Папка приходит пропом: из плоского имени проекта её не вывести.
    const currentFolder = this.props.currentFolder || ROOT_TARGET;
    const availableFolders = (this.props.folders || []).filter(
      (folderId) => folderId !== currentFolder
    );

    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.handleCloseDialog}
        aria-labelledby="move-project-dialog-title"
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle id="move-project-dialog-title">Move Project</DialogTitle>
        <DialogContent>
          {/* Предупреждения про смену project_id больше нет и быть не должно:
              id — имя проекта, перенос его не меняет, и пайплайны команд
              продолжают работать. Раньше id был путём, и это ломалось. */}
          <DialogContentText>
            Moving <code>{projectId}</code> only changes its folder. Its project ID stays the
            same, so CI pipelines and report links keep working.
          </DialogContentText>
          <FormControl fullWidth>
            <InputLabel id="move-project-target-label">Destination folder</InputLabel>
            <Select
              labelId="move-project-target-label"
              id="move-project-target"
              value={this.state.target}
              onChange={this.handleTargetChange}
            >
              <MenuItem value={ROOT_TARGET}>/ root level</MenuItem>
              {availableFolders.map((folderId) => (
                <MenuItem key={folderId} value={folderId}>
                  {folderId}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.handleCloseDialog} variant="text">
            Cancel
          </Button>
          <Button
            onClick={this.moveProject}
            variant="contained"
            color="primary"
            disabled={this.state.target === currentFolder}
          >
            Move
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
export default AllureDockerMoveProjectDialog;
